import React from 'react'

import { type HomepageContent } from '../../types'
import HomeLink from '../HomeLink/HomeLink'
import styles from './styles.module.scss'

type CoreServicesProps = {
  content: HomepageContent['coreServices']
}

const CoreServices = ({ content }: CoreServicesProps) => (
  <section id="core-services" className={styles.section} aria-labelledby="core-services-title">
    <div className={styles.content}>
      <h2 id="core-services-title" className={styles.title}>
        {content.title}
      </h2>
      <div className={styles.services}>
        {content.services.map((service) => (
          <HomeLink
            key={service.title}
            className={styles.service}
            to={service.url}
            tracking={{
              event: 'homepage_service_click',
              tagName: `Homepage service: ${service.title}`,
            }}
          >
            <span>{service.title}</span>
            <span className={styles.arrow} aria-hidden>
              →
            </span>
          </HomeLink>
        ))}
      </div>
    </div>
  </section>
)

export default CoreServices
